import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizContainer } = framework_tool
import 'antd/dist/antd.css';
let {WizSpin,WizButton ,WizRow,WizCol,WizModal} = component_tool;

class NewVersion extends WizContainer {
  componentName = 'newVersion'

  constructor(props) {
    super(props)
    this.state = {
      newVersionInfoList:[],
    };
    this.record={};
  }

  _componentDidMount() {
    const {record={} } = this.props;
    this.record=record;
    this.getNewVersion();
  }

  getNewVersion(){
    this.doAction({
      path: 'proKnowledge/getNewVersion',
      payload: {
        key: 'proKnowledge@getNewVersion',
        apiParams: {
          id:this.record.id
        }
      }
    })
  }

  propsAndStateOnChange = {
    newVersionList: this._newVersionListOver.bind(this)
  }

  _newVersionListOver(nextProps, nextState) {
    if (nextProps.newVersionList.code === 1) {
      nextState.newVersionInfoList = nextProps.newVersionList.data
    }
    return true
  }

  _onClick(version){
    let content = "您即将创建的知识其版本号是"+version+"，是否确认？"
    WizModal.confirm({
      title: "注意",
      content,
      onOk: () => {
        this.jumpPage("push","/proKnowledge/knowledgeBaseList/knowledgeBaseDetailAdd",{version,id:this.record.id,knowledgeTypeId:this.record.proKnowledgeTypeId,versionAdd:true,groupId:this.record.groupId});
      },
      onCancel() {
      },
    });

    
  }

  render() {
    const {proKnowledgeLoading} = this.props
    const { newVersionInfoList} = this.state
    let v1 = newVersionInfoList && newVersionInfoList.length ?newVersionInfoList[0] : undefined
    let v2 = newVersionInfoList && newVersionInfoList.length ?newVersionInfoList[1] : undefined
    let btn= <WizRow>
      <WizCol span="12" style={{textAlign:'center'}}>
      <WizButton  onClick={e =>this._onClick(v1)}>{v1}</WizButton>
      </WizCol>
      <WizCol span="12" style={{textAlign:'center'}}>
      <WizButton  onClick={e =>this._onClick(v2)}>{v2}</WizButton>
      </WizCol>
    </WizRow>
    if(!v2){
      btn = <WizRow>
      <WizCol span="24" style={{textAlign:'center'}}>
      <WizButton  onClick={e =>this._onClick(v1)}>{v1}</WizButton>
      </WizCol>
    </WizRow>
    }
    return (
      <WizSpin  tip={''} spinning={proKnowledgeLoading}>
        {btn}
      </WizSpin>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  const { proKnowledge } = state
  const newVersionList = modelUtils.getModelEntity(proKnowledge, 'proKnowledge@getNewVersion')
  const load = modelUtils.getLoadingState(state, ['proKnowledge']);
  return {
    newVersionList,
    ...load
  }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(NewVersion)
